module.exports = __webpack_public_path__ + "static/img/game-snake.599a7d2.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/works/game-snake.png
 ** module id = 18
 ** module chunks = 1
 **/